globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { createContext, useMemo } from 'react';
import { useVariableOptions, useStatusOptions } from '../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
var GlobalOptionsFetchingContext = /*#__PURE__*/createContext(null);

var GlobalOptionsFetchingProvider = function GlobalOptionsFetchingProvider(_ref) {
  var children = _ref.children;

  var _useVariableOptions = useVariableOptions(),
      variableOptionLoading = _useVariableOptions.loading,
      fetchVariable = _useVariableOptions.fetchVariable,
      variableOptions = _useVariableOptions.variableOptions;

  var _useStatusOptions = useStatusOptions(),
      statusOptionLoading = _useStatusOptions.loading,
      fetchStatus = _useStatusOptions.fetchStatus,
      statusOptions = _useStatusOptions.statusOptions;

  var isLoading = useMemo(function () {
    return variableOptionLoading || statusOptionLoading;
  }, [statusOptionLoading, variableOptionLoading]);
  return /*#__PURE__*/_jsx(GlobalOptionsFetchingContext.Provider, {
    value: {
      fetchVariable: fetchVariable,
      fetchStatus: fetchStatus,
      statusOptions: statusOptions,
      variableOptions: variableOptions,
      isLoading: isLoading
    },
    children: children
  });
};

export { GlobalOptionsFetchingProvider, GlobalOptionsFetchingContext }; // --> types